import { render, staticRenderFns } from "./transfer-print.vue?vue&type=template&id=37fc8953&scoped=true&"
import script from "./transfer-print.vue?vue&type=script&lang=ts&"
export * from "./transfer-print.vue?vue&type=script&lang=ts&"
import style0 from "./transfer-print.vue?vue&type=style&index=0&id=37fc8953&prod&lang=scss&media=print&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fc8953",
  null
  
)

export default component.exports